const it = {
  a11yVideoLabelText: "Video che mostra la verifica della vivacità del viso",
  cameraMinSpecificationsHeadingText: "Specifiche minime della fotocamera",
  cameraMinSpecificationsMessageText:
    "Si prega di assicurarsi che la fotocamera soddisfi le specifiche minime richieste per la verifica della vivacità.",
  cameraNotFoundHeadingText: "Fotocamera non trovata",
  cameraNotFoundMessageText:
    "Non siamo riusciti a rilevare una fotocamera. Si prega di assicurarsi che la fotocamera sia collegata e riprovare.",
  cancelLivenessCheckText: "Annulla verifica della vivacità",
  clientHeaderText: "Messaggio del cliente",
  clientMessageText:
    "Si prega di seguire le istruzioni sullo schermo per completare la verifica della vivacità del viso.",
  connectionTimeoutHeaderText: "Timeout di connessione",
  connectionTimeoutMessageText:
    "La connessione è scaduta. Si prega di controllare la connessione a Internet e riprovare.",
  errorLabelText: "Errore",
  faceDistanceHeaderText: "Distanza del viso",
  faceDistanceMessageText:
    "Si prega di assicurarsi che il viso sia alla giusta distanza dalla fotocamera.",
  goodFitAltText: "Il viso è ben allineato",
  goodFitCaptionText: "Il tuo viso è ben allineato. Si prega di stare fermo.",
  hintCanNotIdentifyText:
    "Impossibile identificare il viso. Si prega di riprovare.",
  hintCenterFaceInstructionText: "Centra il viso nel riquadro.",
  hintCenterFaceText: "Centra il viso",
  hintCheckCompleteText: "Verifica completata",
  hintConnectingText: "Connessione in corso...",
  hintFaceDetectedText: "Viso rilevato",
  hintFaceOffCenterText: "Il tuo viso è decentrato. Si prega di regolare.",
  hintHoldFaceForFreshnessText: "Mantieni il viso fermo per la verifica.",
  hintIlluminationNormalText: "L'illuminazione è buona",
  hintIlluminationTooBrightText: "L'illuminazione è troppo luminosa",
  hintIlluminationTooDarkText: "L'illuminazione è troppo scura",
  hintMatchIndicatorText: "Confronto degli indicatori del viso...",
  hintMoveFaceFrontOfCameraText: "Sposta il viso davanti alla fotocamera",
  hintTooCloseText: "Sei troppo vicino alla fotocamera",
  hintTooFarText: "Sei troppo lontano dalla fotocamera",
  hintTooManyFacesText:
    "Sono stati rilevati troppi visi. Solo un viso deve essere nel riquadro.",
  hintVerifyingText: "Verifica in corso...",
  landscapeHeaderText: "Modalità paesaggio rilevata",
  landscapeMessageText:
    "Si prega di passare alla modalità ritratto per la verifica della vivacità.",
  multipleFacesHeaderText: "Sono stati rilevati più visi",
  multipleFacesMessageText:
    "Solo un viso deve essere nel riquadro. Si prega di regolare e riprovare.",
  photosensitivityWarningBodyText:
    "Questa verifica comporta una serie di stimoli visivi. Se hai problemi di fotosensibilità, procedi con cautela.",
  photosensitivityWarningHeadingText: "Avvertenza di fotosensibilità",
  photosensitivityWarningInfoText:
    "Puoi interrompere la verifica in qualsiasi momento se avverti disagio.",
  photosensitivityWarningLabelText: "Comprendo i rischi",
  portraitMessageText:
    "Si prega di mantenere il dispositivo in modalità ritratto.",
  recordingIndicatorText: "Registrazione in corso",
  retryCameraPermissionsText: "Riprova i permessi della fotocamera",
  serverHeaderText: "Problema del server",
  serverMessageText:
    "C'è stato un problema di connessione al server. Si prega di riprovare più tardi.",
  startScreenBeginCheckText: "Inizia verifica della vivacità",
  timeoutHeaderText: "Timeout",
  timeoutMessageText: "Il processo è scaduto. Si prega di riprovare.",
  tooFarAltText: "Il viso è troppo lontano dalla fotocamera",
  tooFarCaptionText: "Si prega di avvicinarsi alla fotocamera.",
  tryAgainText: "Riprova",
  waitingCameraPermissionText: "In attesa del permesso della fotocamera...",
};

export default it;
